@use '@/styles/tokens' as *;

/* Figma 787:678799 draws both children `flex: 1 0 0`. The row itself — flex, `gap: var(--space-4)`
 * (16) and `margin-top: var(--space-6)` (24) — is already `.actions` in field-details-panel.module.scss. */
.half {
  flex: 1;
}

/* Figma 787:678800 — an outline button with an Error/900 label. `variant="outline"` already carries
 * the transparent fill and the $color-white-600 border (#DEDFDF, the project's name-identical token
 * for Figma's white-600 #DDDEDE); no variant carries a danger LABEL, so this is the one bespoke rule.
 *
 * `!important` for the reason overlay-chrome.module.scss `.danger` needs it: `.button.outline` is a
 * double-class selector in another CSS Module, so a specificity tie would be settled by bundle order. */
.delete {
  color: var(--status-danger-strong) !important;

  &:hover:not(:disabled) {
    color: var(--status-danger-strong) !important;
  }
}
